import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Badge, Dropdown } from 'antd';

import { NewFlatButton } from './redesign/Migration';
import ResendRecordsMenu from './resendRecordsMenu';
import FiltersMenu from './filtersMenu';

class HeaderButtons extends Component {
  render() {
    const { buttons } = this.props;
    return (
      <>
        {
          // Header buttons are mapped in an array and rendered
          buttons.map((button, i) => {
            const buttonKey = button.toolTiptitle || (typeof button.text === 'string' ? button.text : `header-button-${i}`);

            if (button.hide) {
              return null;
            }

            if (button.type === 'dropdown') {
              return (
                <Dropdown
                  key={buttonKey}
                  overlay={button.menu}
                  disabled={button.disabled}
                  trigger={['hover']}
                >
                  <button
                    type="button"
                    style={{
                      color: button.disabled ? 'rgba(0, 0, 0, .25)' : 'rgba(0, 0, 0, .85)',
                      height: '20px',
                      fontSize: '16px',
                      marginLeft: '24px',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '4px',
                      background: 'none',
                      border: 'none',
                      padding: 0,
                      cursor: button.disabled ? 'not-allowed' : 'pointer',
                    }}
                    aria-haspopup="menu"
                    data-tutorial={button.dataTutorial}
                    disabled={button.disabled}
                    onClick={(e) => e.preventDefault()}
                  >
                    <span style={{ display: 'inline-flex', alignItems: 'center' }}>{button.icon}</span>
                    {button.text}
                  </button>
                </Dropdown>
              );
            }
            const headerButton = (
              <NewFlatButton
                label={button.text}
                disabled={button.disabled}
                icon={button.icon}
                onClick={button.resendRecords || button.filterRecords ? () => {} : button.func}
                secondary={button.secondary}
                tooltipTitle={button.toolTiptitle}
                style={{
                  marginLeft: button.resendRecords || button.filterRecords ? '0' : '24px',
                  ...button.style || {},
                }}
              />
            );
            let menuButton = headerButton;

            if (button.resendRecords) {
              menuButton = (
                <ResendRecordsMenu
                  openMenu={button.openMenu}
                  disableSingleResend={button.disableSingleResend}
                  singleResendBlocked={button.singleResendBlocked}
                  handleResendRecord={button.handleResendRecord}
                  handleRequestChange={button.handleRequestChange}
                >
                  {headerButton}
                </ResendRecordsMenu>
              );
            } else if (button.filterRecords) {
              menuButton = (
                <FiltersMenu
                  openFilterMenu={button.openFilterMenu}
                  handleFilter={button.handleFilter}
                  filterOptions={button.filterOptions}
                  handleRequestChange={button.handleRequestChange}
                >
                  {headerButton}
                </FiltersMenu>
              );
            }
            return (
              <div
                key={buttonKey}
                className="header-buttons"
                // Optional stable hook for the "Learn Medsender" guided
                // tutorials; omitted for every button that isn't a tour target.
                data-tutorial={button.dataTutorial}
              >
                <Badge count={button.badgeCount || (button.showBadge ? 'New' : 0)} size="small" offset={[-8, 4]}>
                  {menuButton}
                </Badge>
              </div>
            );
          })
        }
      </>
    );
  }
}

HeaderButtons.propTypes = {
  buttons: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.node.isRequired,
    disabled: PropTypes.bool.isRequired,
    func: PropTypes.func,
    icon: PropTypes.object.isRequired,
    hide: PropTypes.bool,
    passedFuncProps: PropTypes.object,
    dataTutorial: PropTypes.string,
  })).isRequired,
};

export default HeaderButtons;
